import Vue from "vue";
import Vuex from "vuex";
import VueResource from "vue-resource";
import App from "./App.vue";
import validator from "./services/validator.js";
// import helper from './services/helper'
import mainRouter from "./router";
import wakacjeRouter from "./router/wakacje";
import mieszkaniowaLeadsRouter from "./router/mieszkaniowa-leads";
import azkonsultingLeadsRouter from "./router/azk-leads";
import trinityLeadsRouter from "./router/trinity-leads";
import muratorLeadsRouter from "./router/murator-leads";
import hiporankerLeadsRouter from "./router/hiporanker-leads";
import mailingRouter from "./router/mailing";
import leadRouter from "./router/ang-leads";
// import oirpRouter from "./router/oirp-leads";
// import landingRouter from './router/landing'
import Bugsnag from "@bugsnag/js";
import BugsnagPluginVue from "@bugsnag/plugin-vue";
// import './index.css'
import "./assets/tailwind.css";
Vue.use(VueResource);
Vue.use(Vuex);
import store from "./store";
window.Vue = Vue;
// import "tw-elements";

const host = window.location.host;
const parts = host.split(".");

const router = () => {
  let routes;
  let api_params = {
    api_url: process.env.VUE_APP_lead_api_url,
    client_id: process.env.VUE_APP_lead_client_id,
    client_secret: process.env.VUE_APP_lead_client_secret,
  };
  store.commit("api", api_params);
  if (parts[0] === "wakacjekredytowe") {
    routes = wakacjeRouter;
  } else if (parts[0] === "azkonsulting") {
    routes = azkonsultingLeadsRouter;
  } else if (parts[0] === "platforma") {
    routes = mieszkaniowaLeadsRouter;
  } else if (parts[0] === "trinity") {
    routes = trinityLeadsRouter;
  } else if (parts[0] === "murator") {
    routes = muratorLeadsRouter;
  } else if (parts[0] === "hiporanker") {
    routes = hiporankerLeadsRouter;
  } else if (parts[0] === "lead") {
    routes = leadRouter;
  } else if (parts[0] === "mailing") {
    api_params = {
      api_url: process.env.VUE_APP_api_url,
      client_id: process.env.VUE_APP_client_id,
      client_secret: process.env.VUE_APP_client_secret,
    };
    routes = mailingRouter;
  } else {
    api_params = {
      api_url: process.env.VUE_APP_api_url,
      client_id: process.env.VUE_APP_client_id,
      client_secret: process.env.VUE_APP_client_secret,
    };
    store.commit("api", api_params);
    routes = mainRouter;
  }
  return routes;
};

window.router = router();
window.router.beforeEach(function (to, from, next) {
  let split = to.fullPath.split("#");
  if (split.length > 1) {
    next({
      path: split[1],
    });
  } else {
    next();
  }
});

Bugsnag.start({
  apiKey: "578e3aa3f9c85ef436fdffda9b7aec68",
  plugins: [new BugsnagPluginVue()],
});

Vue.config.productionTip = false;

window.Vue.filter("truncate80", function (string) {
  if (!string || string === null) {
    return "";
  }
  let limit = 80;
  if (typeof string === "undefined") {
    return "";
  } else if (string.length > limit) {
    return string.substring(0, limit) + "...";
  } else {
    return string;
  }
});
window.Vue.filter("truncate40", function (string) {
  if (!string || string === null) {
    return "";
  }
  let limit = 40;
  if (typeof string === "undefined") {
    return "";
  } else if (string.length > limit) {
    return string.substring(0, limit) + "...";
  } else {
    return string;
  }
});
window.Vue.filter("truncate30", function (string) {
  if (!string || string === null) {
    return "";
  }
  let limit = 30;
  if (typeof string === "undefined") {
    return "";
  } else if (string.length > limit) {
    return string.substring(0, limit) + "...";
  } else {
    return string;
  }
});
window.Vue.filter("truncate20", function (string) {
  if (!string || string === null) {
    return "";
  }
  let limit = 20;
  if (typeof string === "undefined") {
    return "";
  } else if (string.length > limit) {
    return string.substring(0, limit) + "...";
  } else {
    return string;
  }
});

new Vue({
  router: window.router,
  store: store,
  render: (h) => h(App),
  created() {
    validator.init();
  },
}).$mount("#app");
